﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const __1 = require("..");
class RenewTokenSaga {
    static *watcher() {
        yield effects_1.takeLatest(__1.SagaActions.SagaTriggerActionTypes.TRIGGER_RENEW_TOKEN_SAGA, RenewTokenSaga.worker);
    }
    static *renewTokenSaga(action) {
        console.log('RenewTokenSaga');
        let jwtManager = new operational_context_client_1.JwtManager();
        if (jwtManager.getRawToken()) {
            try {
                if (jwtManager.validateToken()) {
                    let loginClient = new operational_context_client_1.LoginClient();
                    let token = yield effects_1.call([loginClient, loginClient.renewToken]);
                    let payload = jwtManager.save(token);
                    yield effects_1.put(__1.SessionModule.actionCreators.setSession(payload));
                    console.log(`RenewTokenSaga set session`);
                }
            }
            catch (_a) {
                yield effects_1.call(RenewTokenSaga.onErrorUpdatingSession);
            }
            finally {
                if (action) {
                    action();
                }
            }
        }
    }
    static *worker(action) {
        yield effects_1.call(RenewTokenSaga.renewTokenSaga, action.payload);
    }
    static *onErrorUpdatingSession() {
        console.error('RenewTokenSaga: Error updating session');
        yield effects_1.put(__1.SagaActions.actionCreators.triggerLogoutSaga());
    }
}
exports.RenewTokenSaga = RenewTokenSaga;
//# sourceMappingURL=RenewTokenSaga.js.map